import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToTomos = () => {
    document.getElementById('tomos-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-brand-dark overflow-hidden pt-6 pb-10 px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-139">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-teal/20 via-brand-dark to-brand-dark pointer-events-none" data-id="element-140" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative z-10 max-w-2xl mx-auto flex flex-col items-center" data-id="element-141">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/10 text-brand-tealLight text-xs font-semibold mb-3 border border-white/10" data-id="element-142">
          🧪 Hecho por y para estudiantes de Bioquímica · Edición 2026
        </span>

        <h1 className="sm:text-4xl md:text-5xl font-bold text-white mb-4 text-[22px] leading-tight" data-id="element-143">
          DEJA DE ATRASARTE CON TUS MATERIAS: APROBÁ TU PROXIMÓ PARCIAL EN{' '}
          <span className="relative inline-block whitespace-nowrap" data-id="element-144">
            <span className="relative z-10 rounded-lg bg-brand-teal px-2 py-0.5 text-white shadow-lg shadow-brand-teal/30" data-id="element-145">
              14 DÍAS
            </span>
          </span>
        </h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1,
        y: [0, -10, 0]
      }} transition={{
        opacity: {
          duration: 0.6,
          delay: 0.15
        },
        scale: {
          duration: 0.6,
          delay: 0.15
        },
        y: {
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }} src="https://cdn.magicpatterns.com/uploads/vqnuhtqbTzDL4fr9GgCDm7/Untitled_design_(2).png" alt="BioKit Universitario — mockup del sistema completo de apuntes y plantillas de Bioquímica" className="w-full max-w-[336px] sm:max-w-[408px] h-auto mb-4 drop-shadow-2xl" data-id="element-146" />

        <p className="text-sm sm:text-base text-gray-300 mb-5 max-w-xl" data-id="element-147">
          El sistema completo de apuntes, esquemas y herramientas de
          organización para estudiantes que quieren entender de verdad, no solo
          memorizar.
        </p>

        <div className="w-full max-w-md space-y-3 mb-5" data-id="element-148">
          <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full h-[56px] bg-brand-teal text-white font-bold rounded-xl text-base shadow-lg hover:bg-brand-tealLight transition-all active:scale-[0.98] flex items-center justify-center gap-2" data-id="element-149">
            <span data-id="element-150">🧬</span> Quiero el BioKit Universitario
          </button>

          <button onClick={scrollToTomos} className="w-full h-[56px] bg-transparent border-2 border-white text-white font-semibold rounded-xl text-base hover:bg-white/5 transition-all active:scale-[0.98]" data-id="element-151">
            Ver qué incluye ↓
          </button>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1.5 text-xs text-gray-400 font-medium" data-id="element-152">
          <span className="flex items-center gap-1" data-id="element-153">⭐ 4.9/5</span>
          <span data-id="element-154">·</span>
          <span data-id="element-155">+800 estudiantes</span>
          <span data-id="element-156">·</span>
          <span className="flex items-center gap-1" data-id="element-157">📦 6 tomos completos</span>
          <span data-id="element-158">·</span>
          <span className="flex items-center gap-1" data-id="element-159">🔒 Garantía 7 días</span>
        </div>
      </motion.div>
    </section>;
}